import React, { useEffect, useState } from "react";
import "./index.scss";

interface AILoaderProps {
  isShowAILoader: boolean;
  aiLoaderText: string | null;
}

const AILoader: React.FC<AILoaderProps> = ({ isShowAILoader, aiLoaderText }) => {
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!isShowAILoader) return;

    const handleMouseMove = (e: MouseEvent) => {
      setCursorPosition({ x: e.clientX, y: e.clientY });
    };

    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isShowAILoader]);

  if (!isShowAILoader) return null;

  return (
    <section className="ai-loader">
      <div 
        className="cursor-shine" 
        style={{
          left: cursorPosition.x - 50,
          top: cursorPosition.y - 50,
        }}
      />
      <div className="ai-loader-content">
        <div className="ai-image-wrapper">
          <img src="/icons/ai_loader.svg" alt="qualifyme_ai" />
        </div>
        <h3>{aiLoaderText || "Processing..."}</h3>
      </div>
    </section>
  );
};

export default AILoader;
